module.exports = __webpack_public_path__ + "img/spin.4591c86d.svg";